import React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@mui/material/LinearProgress';
import { withStyles } from '@mui/styles';
import { styles } from './styles.js';

const StaticLoader = ({ classes, color }) => {
  return <LinearProgress color={color} className={classes.root} />;
};

StaticLoader.propTypes = {
  classes: PropTypes.object,
  color: PropTypes.string,
};

export default withStyles(styles)(StaticLoader);
